export default __webpack_public_path__ + "static/media/pic10.621a3432.jpg";